
Vue.prototype.translate = function(key) {
    return _.get(window.translations.messages, key, key);
};
